import React from 'react'
import {FormattedMessage, useIntl} from 'react-intl'
import PropTypes from 'prop-types'
import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'
import {
    Divider,
    Flex,
    Modal,
    ModalBody,
    ModalContent,
    ModalHeader,
    ModalOverlay,
    Text,
    useMultiStyleConfig,
} from '@chakra-ui/react'
import {CloseIcon} from '../../../components/icons'
import DynamicImage from '../../../components/dynamic-image'

const ProductCodeModal = ({isOpen, onClose}) => {
    const styles = useMultiStyleConfig('Manuals')
    const {formatMessage} = useIntl()
    return (
        <Modal isOpen={isOpen} isCentered>
            <ModalOverlay />
            <ModalContent {...styles.manualsModalContent} mx={{base: 4, md: 0}}>
                <ModalHeader {...styles.manualsModalHeader}>
                    <Flex justifyContent="space-between" flexDir="row-reverse">
                        <CloseIcon
                            data-testid="product-code-modal-close"
                            onClick={onClose}
                            tabIndex={0}
                            aria-label={formatMessage({
                                id: 'country.banner.close',
                                defaultMessage: 'Close',
                            })}
                            role="button"
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault()
                                    onClose()
                                }
                            }}
                        />
                        <Text {...styles.manualsModalTitle} data-testid="product-code-modal-title">
                            <FormattedMessage
                                defaultMessage="Where to find your product number"
                                id="manuals-page.header-find-product-number-label"
                            />
                        </Text>
                    </Flex>
                    <Divider {...styles.headerDivider} />
                </ModalHeader>
                <ModalBody {...styles.manualsModalBody}>
                    <Flex {...styles.modalInstructionsContainer}>
                        <Text>
                            <FormattedMessage
                                defaultMessage="Indicate the model type or its number in the form"
                                id="manuals-page.header.modal-content.primary.label"
                            />
                        </Text>
                        <Text>
                            <FormattedMessage
                                defaultMessage="The model number can usually be located on the back or base of the product either on a white or silver label like this:"
                                id="manuals-page.header.modal-content.secondary.label"
                            />
                        </Text>
                    </Flex>
                    <Flex justifyContent="center">
                        <DynamicImage src={getAssetUrl('/static/img/product-code-image.png')} />
                    </Flex>
                </ModalBody>
            </ModalContent>
        </Modal>
    )
}

ProductCodeModal.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
}

export default ProductCodeModal
